import { useEffect, useRef } from 'react'

import { cn } from '@/utils/cn'

interface SearchInputProps {
  value: string
  onChange: (v: string) => void
  onClose: () => void
  className?: string
}

export function SearchInput({ value, onChange, onClose, className }: SearchInputProps) {
  const ref = useRef<HTMLInputElement>(null)

  useEffect(() => {
    ref.current?.focus()
  }, [])

  return (
    <div className={cn('relative flex items-center', className)}>
      {/* Search icon */}
      <svg
        className="pointer-events-none absolute left-3 h-4 w-4 shrink-0 text-tv-text-secondary"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M21 21l-4.35-4.35M17 11A6 6 0 1 1 5 11a6 6 0 0 1 12 0z"
        />
      </svg>

      <input
        ref={ref}
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Escape') {
            e.stopPropagation()
            onClose()
          }
        }}
        placeholder="Search symbols, indices, crypto…"
        spellCheck={false}
        autoComplete="off"
        autoCorrect="off"
        className={cn(
          'w-full border-0 bg-transparent py-3 pl-9 pr-8 text-base text-tv-text-primary',
          'placeholder:text-tv-text-muted focus:outline-none focus:ring-0'
        )}
      />

      {/* Clear button */}
      {value && (
        <button
          type="button"
          onClick={() => onChange('')}
          className="absolute right-3 flex h-5 w-5 items-center justify-center rounded-sm text-tv-text-secondary hover:text-tv-text-primary"
          tabIndex={-1}
        >
          <svg viewBox="0 0 16 16" fill="currentColor" className="h-3.5 w-3.5">
            <path d="M4.293 4.293a1 1 0 0 1 1.414 0L8 6.586l2.293-2.293a1 1 0 1 1 1.414 1.414L9.414 8l2.293 2.293a1 1 0 0 1-1.414 1.414L8 9.414l-2.293 2.293a1 1 0 0 1-1.414-1.414L6.586 8 4.293 5.707a1 1 0 0 1 0-1.414z" />
          </svg>
        </button>
      )}
    </div>
  )
}
